import { FC } from 'react';

import { Modal } from '../../../../components/modal/index';
import { popupStore } from './popup.store';

export const CancelPerkEditingPopup: FC = () => {
  const isOpen = popupStore(({ open }) => open);

  const handleAccept = popupStore(({ handleAccept }) => handleAccept);
  const handleDismiss = popupStore(({ handleDismiss }) => handleDismiss);

  return (
    <Modal
      description="Are you sure you want to discard changes? The perk not be saved and all unsaved data will be lost. "
      dismissButtonContent="Back"
      isOpen={isOpen}
      onDismiss={handleDismiss}
      onSuccess={handleAccept}
      successButtonClassName="bg-brand-700"
      successButtonContent="Cancel"
      title="Cancel Perk editing?"
    />
  );
};
